module.exports = "images/enfants_12.2515b691.png";